<template>
    <v-container>
        <h2>
            <span v-if="stack.api.getLoaded">{{ stack.name }}</span>
<!--            <v-btn-->
<!--                    v-if="canEditStacks"-->
<!--                    secondary-->
<!--                    @click="editStack()"-->
<!--            >-->
<!--                <v-icon left>mdi-pencil></v-icon> {{ $t('nav.edit') }}-->
<!--            </v-btn>-->
        </h2>

        <v-simple-table v-if="cards">
            <thead>
            <th v-if="canEditCards">{{ $t('heading.frontLang') }}</th>
            <th>{{ $t('heading.front') }}</th>
            <th v-if="canEditCards">{{ $t('heading.backLang') }}</th>
            <th>{{ $t('heading.back') }}</th>
            </thead>
            <tbody>
            <tr
                    v-for="(card, index) in cards.list"
                    :key="card.id"
                    @click="editCard(index)"
            >
                <td v-if="canEditCards">{{ card.lang }}</td>
                <td :class="langCss(card.lang)" v-html="toHtml(card.front, card.lang)"></td>
                <td v-if="canEditCards">{{ card.backLang }}</td>
                <td :class="langCss(card.backLang)" v-html="toHtml(card.back, card.backLang)"></td>
            </tr>
            </tbody>
        </v-simple-table>
        <card-edit
                v-if="canEditCards"
                :pk="editId"
                v-model="showDialog"
                @closed="showDialog = false"
                @saved="updateCard($event)"
        ></card-edit>
    </v-container>
</template>

<script>
    // import ListBase from "../bases/ListBase";
    import {joinUrls} from "@/lib/funclib";
    import basic from "../mixins/basic";
    import CardEdit from "../cards/CardEdit";
    import {Stack} from "@/models/Stack";
    import {CardList} from "../../models/Card";

    export default {
        name: "StackCardList",
        components: {CardEdit},
        mixins: [basic],
        props: {
            pk: {
                required: true,
                type: Number,
            }
        },
        data () {
            return {
                cards: new CardList(),
                editId: 0,
                editIndex: null,
                showDialog: false,
                stack: new Stack(),
            }
        },
        methods: {
            getListUrl () {
                return joinUrls('/stack/', String(this.pk), '/cards/');
            },
            getStack () {
                this.stack.api.fetch(this.pk);
            },
            editCard (index) {
                if (this.canEditCards) {
                    this.editId = this.cards.list[index].id;
                    this.editIndex = index;
                    this.showDialog = true;
                }
            },
            updateCard (card) {
                if (this.canEditCards) {
                    this.cards.list[this.editIndex].front = card.front;
                    this.cards.list[this.editIndex].lang = card.lang;
                    this.cards.list[this.editIndex].back = card.back;
                    this.cards.list[this.editIndex].backLang = card.backLang;
                }
            }
        },
        computed: {
        },
        created () {
            this.cards.api.fetch(this.pk);
            this.getStack();
        }
    }
</script>

<style scoped>
    .component-HE {
        font-size: 140%;
    }
    .component-AR {
        font-size: 120%;
    }
    .component-EN {
        font-size: 110%;
    }
</style>
